import(/* webpackMode: "eager", webpackExports: ["PoolsFiltersProvider"] */ "/home/runner/work/dex-frontend/dex-frontend/apps/web/src/app/(networks)/_ui/pools-filters-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationItems"] */ "/home/runner/work/dex-frontend/dex-frontend/apps/web/src/app/(networks)/(evm)/(positions)/navigation-items.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/runner/work/dex-frontend/dex-frontend/apps/web/src/app/(networks)/(evm)/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LinkInternal"] */ "/home/runner/work/dex-frontend/dex-frontend/packages/ui/dist/components/link.js");
